export default "__VITE_ASSET__CtG5ycBp__"